import { Inject, Service } from 'typedi';
import { BaseHttp } from '@enterprise/common';
import { ConstantsStore } from '../store';
import { GetCombinedItemQuery, CombinedItemResponse, BulkUpdateCombinedItemBody, CombinedItem } from '../core/models';
import { ItemsGroupByType } from '../core/models/organization/settings/enum';
import { first } from 'lodash';
import { TaskResponse } from '../core/interfaces/TaskResponse';

export const COMBINED_ITEMS_PATH = 'v2/combined-items';

export interface ScheduleSaveOptions {
    isUpdatingExistingItem?: boolean;
    name: string;
    runAt?: Date;
}

@Service()
export class CombinedItemService {
    constructor(@Inject('http') private readonly http: BaseHttp, private readonly constantsStore: ConstantsStore) {}

    get itemsGroupBy(): ItemsGroupByType {
        return this.constantsStore.organizationSettings?.itemsGroupBy || ItemsGroupByType.Id;
    }

    async getItem({ pimsGeneratedId, siteId }: GetCombinedItemQuery): Promise<CombinedItemResponse> {
        const id = Array.isArray(pimsGeneratedId) ? first(pimsGeneratedId) : pimsGeneratedId;

        return await this.http.get(`${COMBINED_ITEMS_PATH}/:id`, { params: { siteId }, pathParams: { id } });
    }

    async getItems<T = CombinedItem>(criteria: GetCombinedItemQuery = {}): Promise<CombinedItemResponse<T>> {
        return await this.http.get(COMBINED_ITEMS_PATH, { params: criteria });
    }

    async createBulkUpdate(update: BulkUpdateCombinedItemBody): Promise<TaskResponse> {
        return await this.http.post(`${COMBINED_ITEMS_PATH}/bulk`, update);
    }
}
